<script setup>
defineProps({
    categories: { type: Array, default: () => [] },
    activeSlug: { type: String, default: '' },
})
</script>

<template>
    <nav
        class="flex flex-wrap gap-2"
        v-if="categories.length"
        aria-label="Rubriky blogu"
    >
        <Link
            class="rounded-full px-4 py-2 text-sm font-semibold transition-colors"
            :class="activeSlug ? 'text-brand-900 hover:bg-zinc-100' : 'bg-brand-900 text-white'"
            href="/blog"
        >
            Vše
        </Link>

        <Link
            class="rounded-full px-4 py-2 text-sm font-semibold transition-colors"
            v-for="category in categories"
            :key="category.slug"
            :href="`/blog/rubrika/${category.slug}`"
            :class="activeSlug === category.slug ? 'bg-brand-900 text-white' : 'text-brand-900 hover:bg-zinc-100'"
        >
            {{ category.name }}
        </Link>
    </nav>
</template>
